import React, { forwardRef, useImperativeHandle } from 'react';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

const Recaptcha = forwardRef((props, ref) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_SITE_KEY_GOOGLE}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <RecaptchaController ref={ref} />
    </GoogleReCaptchaProvider>
  );
});

const RecaptchaController = forwardRef((props, ref) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useImperativeHandle(ref, () => ({
    execute: async (action = 'submit_form') => {
      if (!executeRecaptcha) {
        console.error('reCAPTCHA no está disponible todavía.');
        return null;
      }

      return executeRecaptcha(action);
    },
  }), [executeRecaptcha]);

  return null;
});

export default Recaptcha;